import type { BffShoppingCart } from '@/core/models/bff-shopping-carts';

export default function getBffCartItemCount(
  cart: BffShoppingCart | undefined,
): number {
  if (!cart) return 0;
  const productQty = (cart.products ?? []).reduce(
    (sum, p) => sum + p.quantity,
    0,
  );
  const subscriptionQty = (cart.subscriptions ?? []).reduce(
    (sum, s) => sum + s.quantity,
    0,
  );
  return productQty + subscriptionQty;
}
